import { render, staticRenderFns } from "./headTitle.vue?vue&type=template&id=6d0ce775&scoped=true&"
import script from "./headTitle.vue?vue&type=script&lang=js&"
export * from "./headTitle.vue?vue&type=script&lang=js&"
import style0 from "./headTitle.vue?vue&type=style&index=0&id=6d0ce775&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0ce775",
  null
  
)

export default component.exports